// extracted by mini-css-extract-plugin
export default {"wrapper":"AccountMenu_wrapper__1odsM","userName":"AccountMenu_userName__dNN5e","avatar":"AccountMenu_avatar__Fi5O9","popover":"AccountMenu_popover__7f1rJ"};